import React from 'react';
import { Card } from '../../ui';
import SkeletonLoader from './SkeletonLoader';

const UpcomingPostsSkeleton = () => (
  <Card>
    <Card.Body>
      <SkeletonLoader count={4} />
    </Card.Body>
  </Card>
);

export default UpcomingPostsSkeleton;
